import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 275px;
  height: 100%;

  svg {
    width: 100%;
    height: auto;
    overflow: visible;
  }
`;

